module.exports = __webpack_public_path__ + "static/img/v1.5484ef2.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/v1.png
// module id = xgxP
// module chunks = 1